"use strict";

exports.__esModule = true;
exports.use = exports.t = exports.i18n = exports.default = void 0;
var _zhCN = _interopRequireDefault(require("../../lib/locale/lang/zh-CN"));
var _vue = _interopRequireDefault(require("vue"));
var _deepmerge = _interopRequireDefault(require("deepmerge"));
var _format = _interopRequireDefault(require("./format"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const format = (0, _format.default)(_vue.default);
let lang = _zhCN.default;
let merged = false;
let i18nHandler = function () {
  const vuei18n = Object.getPrototypeOf(this || _vue.default).$t;
  if (typeof vuei18n === 'function' && !!_vue.default.locale) {
    if (!merged) {
      merged = true;
      _vue.default.locale(_vue.default.config.lang, (0, _deepmerge.default)(lang, _vue.default.locale(_vue.default.config.lang) || {}, {
        clone: true
      }));
    }
    return vuei18n.apply(this, arguments);
  }
};
const t = function (path, options) {
  let value = i18nHandler.apply(this, arguments);
  if (value !== null && value !== undefined) return value;
  const array = path.split('.');
  let current = lang;
  for (let i = 0, j = array.length; i < j; i++) {
    const property = array[i];
    value = current[property];
    if (i === j - 1) return value ? format(value, options) : '';
    if (!value) return '';
    current = value;
  }
  return '';
};
exports.t = t;
const use = function (l) {
  lang = l || lang;
};
exports.use = use;
const i18n = function (fn) {
  i18nHandler = fn || i18nHandler;
};
exports.i18n = i18n;
var _default = exports.default = {
  use,
  t,
  i18n
};